import { render, staticRenderFns } from "./base-footer.vue?vue&type=template&id=0cbe02f6&"
import script from "./base-footer.vue?vue&type=script&lang=js&"
export * from "./base-footer.vue?vue&type=script&lang=js&"
import style0 from "./base-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustpilotStars: require('/usr/src/app/components/common-sections/trustpilot-stars.vue').default})
